import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeather: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFeather"><Path d="M6 21C6 20.3294 6.01999 19.6613 6.06112 18.9995C10.3559 18.9688 17.2175 16.2636 17.6626 11.1219L16.1453 9.98395C16.5449 9.64005 17.0183 9.19679 17.4933 8.66896C18.679 7.35147 20 5.36811 20 3V2H19C13.4088 2 9.59397 4.42358 7.22335 8.0811C4.89114 11.6794 4 16.396 4 21V22H6V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFeather;
